module.exports = __mpx_resolve_path__("/home/runner/work/mpx-cube-ui/mpx-cube-ui/packages/mpx-cube-ui/src/components/sticky/sticky-ele/index.mpx?resolve")